// extracted by mini-css-extract-plugin
export default {"mobile":"mobile_mobile__YrPJt","button":"mobile_button__TCCpd"};